import { CoolMultiCardCarouselCardItemContainer } from './styledComponents'

export default function CoolCardItem({
  headingIconComponent = <></>,
  heading,
  subHeading,
  description,
  extraStyles = {},
}) {
  return (
    <CoolMultiCardCarouselCardItemContainer style={extraStyles}>
      {headingIconComponent}
      {heading && <div className="heading">{heading}</div>}
      <div className="d-flex flex-column align-items-center gap-1">
        {subHeading && <div className="sub-heading">{subHeading}</div>}
        <div className="description">{description}</div>
      </div>
    </CoolMultiCardCarouselCardItemContainer>
  )
}
